import React from "react";

const NoResultsFound = () => {
  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>No Results Found</h2>
      <p style={styles.message}>
        Sorry, we couldn't find any matching results. Please try again with
        different keywords.
      </p>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "60vh",
    padding: "30px",
    textAlign: "center",
    margin: "0 auto",
    maxWidth: "500px",
  },
  heading: {
    fontSize: "28px",
    color: "#F1591E",
    fontWeight: "600",
    marginBottom: "15px",
  },
  message: {
    fontSize: "16px",
    color: "#777",
    marginTop: "10px",
    lineHeight: "1.5",
  },
};

export default NoResultsFound;
